import axios from "axios";

import { API_BASE_URL } from '../utils/constants';

const API_URL = API_BASE_URL + "auth/";

class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "signin", {
        username,
        password
      })
      .then(response => {
        if (response.data.accessToken) {
            this.setCurrentUser(response.data);
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));;
  }

  setCurrentUser(userData) {
    localStorage.setItem("user", JSON.stringify(userData));
  }
}

export default new AuthService();